import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { LocationType } from '~/models/modules/locationType';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class LocationTypesService extends ApiServiceBase {
  locationTypeAdded: EventEmitter<any> = new EventEmitter();
  locationTypeUpdated: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getLocationType(id: number) {
    return this.http.get<LocationType>(this._url(`/${id}`));
  }

  getLocationTypeListing() {
    return this.http.get<LocationType[]>(this._url());
  }

  getLocationTypeListingByAccount(model: any = null) {
    return this.http.post<LocationType[]>(this._url(`/LocationTypesByAccounts`), model);
  }


  getLocationTypes(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<LocationType[]>(this._url(`/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  createLocationType(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateLocationType(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  // deleteLocationType(id: number) {
  //     return this.client.delete(this._url(`/${id}`));
  // }
  // deactivateLocationType(obj: any) {
  //     return this.client.put(this._url(`/deactivate`), obj);
  // }

  activatedeactivateLocationTypeBatch(obj: any) {
    return this.client.put(this._url(`/batchactivatedeactivate`), obj);
  }
  // reactivateLocationType(obj: any) {
  //   return this.client.put(this._url(`/reactivate`), obj);
  // }

  getStockNumberByDate(id: number) {
    return this.client.get(this._url(`/stock-by-date/${id}`));
  }

  getInventoryidnumberInLocationByDate(id: number) {
    return this.client.get(this._url(`/inventory-per-location-by-date/${id}`));
  }
  getQtyItemPerCategoryByDate(id: number) {
    return this.client.get(this._url(`/Qty-item-per-category-by-date/${id}`));
  }


  GetLocationTypeChart(locationTypeId: number) {
    return this.client.get(this._url(`/LocationTypes/${locationTypeId}/Chart`));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/LocationTypes${v}`);
  }
}
